// extracted by mini-css-extract-plugin
export default {"mainText":"ConfirmGenerateModal_mainText__v8ksp","warningNote":"ConfirmGenerateModal_warningNote__SHg68"};